<template>
  <div>
    <v-row v-if="isRestricted">
      <v-col cols="12" class="text-center">
        <v-icon size="256">
          mdi-alert
        </v-icon>
      </v-col>

      <v-col cols="12" class="text-center">
        <gg-card-title>
          This feature requires an Upgrade
        </gg-card-title>
      </v-col>

      <v-col cols="12" class="subtitle-1 text-center">
        The ability to host multiple domain names on your account is not available on your current subscription. You
        will need to upgrade your plan.
      </v-col>

      <v-col cols="12" class="text-center">
        <gg-btn :to="{
          name: 'support_ticketnew',
          query: {
            sbj: 'Upgrade my account',
            d: 'Sales',
            s: $attrs.hostingid
          }}">
          Upgrade now
        </gg-btn>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="12">
        <create-addon-domain-form @addondomain-created="reloadTable" />
      </v-col>
      <v-col cols="12">
        <addon-domains-table :table-should-be-reloaded="tableShouldBeReloaded"
                             @table-reloaded="tableReloaded"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CreateAddonDomainForm from '@/components/Services/Hosting/Shared/Domains/AddonDomains/CreateAddonDomainForm'
import AddonDomainsTable from '@/components/Services/Hosting/Shared/Domains/AddonDomains/AddonDomainsTable'

export default {
  name: 'AddonDomainsView',
  components: {
    CreateAddonDomainForm,
    AddonDomainsTable,
  },
  data () {
    return {
      tableShouldBeReloaded: false,
    }
  },
  computed: {
    ...mapGetters(['hosting_detail']),
    isRestricted () {
      return this.hosting_detail?.accountsummary?.plan === 'ecosite_lite'
    }
  },
  methods: {
    reloadTable () {
      this.tableShouldBeReloaded = true
    },
    tableReloaded () {
      this.tableShouldBeReloaded = false
    },
  },
}
</script>
